export default {
  // 申請入口
  apply: {
    title: '申請儲值會員',
    button: '申請儲值會員',
    viewLedger: '儲值帳本',
  },

  // 服務條款
  terms: {
    title: '儲值會員服務條款',
    subtitle: '請仔細閱讀以下條款，確認後方可繼續申請',
    agree: '我已閱讀並同意以上條款',
    continue: '繼續申請',
    back: '返回',
    content: {
      section1: {
        title: '一、服務說明',
        items: [
          '儲值會員為預付費制度，客戶需先儲值後方可使用儲值金額進行租借。',
          '儲值金額分為「實體金額」與「贈送金額」兩部分。',
          '實體金額為客戶實際支付的金額，可開立發票；贈送金額為平台贈送，不可退款。',
        ],
      },
      section2: {
        title: '二、儲值規則',
        items: [
          '儲值方案由平台制定，客戶可選擇適合的方案進行申請。',
          '申請後需經總店長審核通過，並於現場完成付款後開通。',
          '儲值金額將於付款完成後立即存入客戶的儲值帳戶。',
        ],
      },
      section3: {
        title: '三、使用規則',
        items: [
          '訂單確認後，系統將自動從儲值帳戶扣款。',
          '扣款順序：優先扣除實體金額，不足時扣除贈送金額。',
          '實體金額消費部分將開立發票，贈送金額消費部分不開立發票。',
          '儲值餘額低於 NT$ 3,000 時，系統將提醒您進行儲值。',
        ],
      },
      section4: {
        title: '四、退款規則',
        items: [
          '實體金額可申請退款，但需扣除已使用的贈送金額對應的實體金額。',
          '贈送金額不可退款，不可轉讓。',
          '退出儲值會員身份時，必須確保實體金額已歸零。',
        ],
      },
      section5: {
        title: '五、其他注意事項',
        items: [
          '儲值金額不可轉讓給其他客戶。',
          '平台保留修改儲值方案的權利，但不影響已儲值的金額。',
          '如有任何疑問，請聯繫客服人員。',
        ],
      },
    },
  },

  // 方案介紹
  plans: {
    title: '選擇儲值方案',
    subtitle: '選擇適合您的儲值方案，享受更多優惠',
    realAmount: '儲值金額',
    bonusAmount: '贈送金額',
    totalAmount: '實得金額',
    bonusRate: '贈送比例',
    select: '選擇此方案',
    selected: '已選擇',
    popular: '熱門',
    recommended: '推薦',
  },

  // 申請表單
  application: {
    title: '確認申請資訊',
    subtitle: '請確認您的申請資訊，提交後將進入審核流程',
    selectedPlan: '選擇的方案',
    customerInfo: '客戶資訊',
    name: '姓名',
    email: 'Email',
    phone: '電話',
    notes: '備註（選填）',
    notesPlaceholder: '如有特殊需求，請在此說明...',
    agreeTerms: '我已閱讀並同意服務條款',
    submit: '提交申請',
    submitting: '提交中...',
    back: '返回',
    success: '申請提交成功！',
    successMessage: '您的申請已提交，請等待管理員審核通知。審核通過後，請前往現場完成付款開通。',
    error: '申請失敗',
    errorMessage: '提交申請時發生錯誤，請稍後再試。',
  },

  // 申請狀態
  status: {
    pending: '待審核',
    approved: '已核准',
    rejected: '已拒絕',
    paid: '已付款',
    cancelled: '已取消',
    pendingDesc: '您的申請正在審核中，請耐心等待',
    approvedDesc: '申請已通過，請前往現場完成付款',
    rejectedDesc: '申請未通過',
    paidDesc: '付款完成，儲值帳戶已開通',
    cancelledDesc: '申請已取消',
  },

  // 申請查詢
  myApplication: {
    title: '我的申請',
    noApplication: '尚無申請記錄',
    appliedAt: '申請時間',
    reviewedAt: '審核時間',
    paymentAt: '付款時間',
    plan: '申請方案',
    status: '申請狀態',
    notes: '備註',
    rejectionReason: '拒絕原因',
    viewDetails: '查看詳情',
  },

  // 儲值帳本
  ledger: {
    title: '儲值帳本',
    subtitle: '查看您的儲值餘額與交易記錄',
    accountBalance: '帳戶餘額',   // ← 已改名以避免重複鍵
    realBalance: '實體金額',
    bonusBalance: '贈送金額',
    totalBalance: '總餘額',
    statistics: '統計資訊',
    totalDeposited: '累計儲值',
    totalBonus: '累計贈送',
    totalSpent: '累計消費',
    lowBalanceWarning: '餘額不足',
    lowBalanceMessage: '您的儲值餘額低於 NT$ 3,000，建議盡快儲值以免影響租借。',
    recharge: '立即儲值',
    transactions: '交易記錄',
    noTransactions: '尚無交易記錄',
    date: '日期',
    type: '類型',
    amount: '金額',
    balance: '餘額',   // 這是表格欄位的標題
    description: '說明',
    viewOrder: '查看訂單',
    deposit: '儲值',
    deduct: '扣款',
    refund: '退款',
    bonus: '贈送',
    adjustment: '調整',
  },

  // 通用
  common: {
    loading: '載入中...',
    error: '發生錯誤',
    retry: '重試',
    close: '關閉',
    confirm: '確認',
    cancel: '取消',
    save: '儲存',
    edit: '編輯',
    delete: '刪除',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    currency: 'NT$',
  },
};